'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuOptions = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(MenuOptions, _Component);

  function MenuOptions() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuOptions.__proto__ || (0, _getPrototypeOf2.default)(MenuOptions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuOptions, [{
    key: 'onOverlay',
    value: function onOverlay() {
      var _props = this.props,
          onHide = _props.onHide,
          backdrop = _props.backdrop;

      if (backdrop !== 'static') {
        onHide();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./MenuOptions.scss');
      var _props2 = this.props,
          title = _props2.title,
          show = _props2.show,
          children = _props2.children,
          onHide = _props2.onHide,
          closeButton = _props2.closeButton;

      return _react2.default.createElement(
        'div',
        { className: styles.menu + ' ' + (show ? styles.show : '') },
        _react2.default.createElement('div', { className: styles.overlay, onClick: this.onOverlay.bind(this) }),
        _react2.default.createElement(
          'div',
          { className: styles.optionAnimate },
          _react2.default.createElement(
            'div',
            { className: styles.optionBox },
            _react2.default.createElement(
              'div',
              { className: styles.optionHead },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                title
              ),
              closeButton && _react2.default.createElement(
                'div',
                { className: styles.btnClose, onClick: onHide },
                _react2.default.createElement('i', { className: 'fa fa-close' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.optionBody },
              children
            )
          )
        )
      );
    }
  }]);
  return MenuOptions;
}(_react.Component), _class.propTypes = {
  // options: PropTypes.array,
  title: _react.PropTypes.string,
  show: _react.PropTypes.bool,
  closeButton: _react.PropTypes.bool,
  backdrop: _react.PropTypes.string,
  children: _react.PropTypes.object,
  // @action
  onHide: _react.PropTypes.func
}, _temp2);
exports.default = MenuOptions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/MenuOptions.js
// module id = 1560
// module chunks = 0